export default __webpack_public_path__ + "static/media/Group11903b.5cf44e4e.svg";